module.exports = __webpack_public_path__ + "static/media/227.c9616995.svg";